<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <choose-server-step v-if="currentStep == 'choose_server_step'"></choose-server-step>
            <ssh-key-step v-if="currentStep == 'ssh_key_step'" :server="selectedServer"></ssh-key-step>
            <database-details-step v-if="currentStep == 'database_details_step'" :server="selectedServer" :database-type="databaseType"></database-details-step>
            <select-databases-step v-if="currentStep == 'select_databases_step'" :server="selectedServer" :credentials="credentials" :database-type="databaseType"></select-databases-step>

            <!-- <div class="default-settings-title">
                <span class="account-name">Step 1: Database server</span>
                <span class="default-settings-subtitle">The server on which the database is running.</span>
            </div> -->

            <!-- <div class="backup" style="margin-bottom: 30px !important">
                <div class="columns is-multiline">
                    <div @click="selectProvider('mysql')" class="column is-4">
                        <div class="backup-frequency backup-frequency-selectable" :class="{'backup-frequency-selected': selectedProvider('mysql')}">
                            <div class="icon-db">
                                <img src="/databases/mysql.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Database type
                                </div>
                                <div class="detail-value">
                                    MySQL
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('postgresql')" class="column is-4">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('postgresql')}">
                            <div class="icon-db">
                                <img src="/databases/postgresql.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Database type
                                </div>
                                <div class="detail-value">
                                    PostgreSQL
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div class="column is-4">
                        <div class="backup-retention backup-retention-selectable cursor-not-allowed">
                            <div class="icon-db">
                                <img src="/databases/mongodb.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Database type
                                </div>
                                <div class="detail-value">
                                    MongoDB
                                </div>
                            </diV>
                        </div>
                    </div>

                    <div class="column is-12" v-show="selectedProvider('mysql')">
                        <mysql-provider></mysql-provider>
                    </div>

                    <div class="column is-12" v-show="selectedProvider('postgresql')">
                        <postgresql-provider></postgresql-provider>
                    </div>
                </div>
            </div> -->

            <!-- <div class="columns is-multiline">
                <div class="column is-3">
                    <div @click="emitStoreDatabaseEvent" :disabled="storingDatabase" :class="{ 'is-loading': storingDatabase }" class="button custom-button-size is-fullwidth is-info">Next</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="storingDatabase">Cancel</div>
                </div>
            </div> -->
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
// import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    props: ['databaseType'],

    components: {
        'mysql-provider': require('@/components/Databases/Providers/MySQL.vue').default,
        'postgresql-provider': require('@/components/Databases/Providers/PostgreSQL.vue').default,
        'choose-server-step': require('@/components/Databases/AddDatabase/ChooseServerStep.vue').default,
        'ssh-key-step': require('@/components/Databases/AddDatabase/SshKeyStep.vue').default,
        'database-details-step': require('@/components/Databases/AddDatabase/DatabaseDetailsStep.vue').default,
        'select-databases-step': require('@/components/Databases/AddDatabase/SelectDatabasesStep.vue').default,
        // 'hetzner-provider': require('@/components/Accounts/Providers/Hetzner.vue').default,
    },

    data() {
        return {
            active: false,
            name: '',
            token: '',
            providerSlug: 'mysql',
            storingDatabase: false,
            //
            currentStep: 'choose_server_step',
            selectedServer: null,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        nextStep(step, data) {
            //
        },

        // addAccount() {
        //     Api().post('accounts')
        //         .then(response => {
        //
        //         })
        //         .catch(error => {
        //
        //         })
        //         .finally(() => {
        //             //
        //         })
        //     ;
        // },

        emitStoreDatabaseEvent() {
            Event.$emit('storeDatabase');
        },

        close() {
            if (!this.storingDatabase) {
                this.active = false;
                Event.$emit('addDatabaseClosed');
            }
        },

        listenEvents() {
            var vm = this;

            Event.$on('showAddDatabase', () => {
                vm.active = true;
            });

            Event.$on('closeAddDatabase', () => {
                vm.close();
            });

            Event.$on('storingDatabaseLoaderUpdated', (storingDatabase) => {
                vm.storingDatabase = storingDatabase;
            });

            //

            Event.$on('moveToSshKeyStep', (server) => {
                this.selectedServer = server;
                this.currentStep = 'ssh_key_step';
            });

            Event.$on('moveToDatabaseDetailsStep', (server) => {
                this.selectedServer = server;
                this.currentStep = 'database_details_step';
            });

            Event.$on('moveToSelectDatabasesStep', (credentials, databaseType) => {
                this.currentStep = 'select_databases_step';
                this.credentials = credentials;
                this.databaseType = databaseType;
            });
        },

        selectedProvider(providerSlug) {
            return this.providerSlug === providerSlug;
        },

        selectProvider(providerSlug) {
            this.providerSlug = providerSlug;
        },
    },

    watch: {
        currentStep(currentStep) {
            Event.$emit('currentAddServerStepUpdated', currentStep);
        },
    },
}
</script>
